import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
require("../../Content/Less/validationStyles.css");

class Validator extends Component {
  renderInlineMsg = () =>{
    if (this.props.isValid || !this.props.msg) return null;
    return  <span
              className="field-error"
              ref="errorMessage">
              {this.props.msg}
            </span>
  };
  getCompClass = () =>{
    var baseClass = 'validator ';
    if (this.props.isValid) return baseClass;
    return baseClass + 'has-error';
  };
  render() {
    return (
      <div style={[this.props.style && this.props.style]} className={this.getCompClass()}>
        {this.props.children}
        {this.renderInlineMsg()}
      </div>
    );
  }
}
  Validator.propTypes = {
    msg: PropTypes.string,
    isValid: PropTypes.bool.isRequired,
    style: PropTypes.string
  };
export default Radium(Validator);


// WEBPACK FOOTER //
// ./src/App/Common/validator.jsx